import { initializeAppCheck, ReCaptchaEnterpriseProvider } from 'firebase/app-check';
import { app, useEmulators } from './firebase';

/**
 * Firebase App Check with reCAPTCHA Enterprise. No-op against the emulators or when no site key is
 * configured, so local development and CI keep working. In dev builds the SDK prints a debug token
 * to the console; register it under App Check → Apps → Manage debug tokens to test against production.
 */
export function initAppCheck(): void {
  const key = import.meta.env.VITE_RECAPTCHA_SITE_KEY as string | undefined;
  if (useEmulators || !key) return;
  if (import.meta.env.DEV)
    (self as unknown as { FIREBASE_APPCHECK_DEBUG_TOKEN?: boolean }).FIREBASE_APPCHECK_DEBUG_TOKEN = true;
  initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider(key),
    isTokenAutoRefreshEnabled: true,
  });
}
